var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 1.66699C5.90866 1.66699 2.16699 5.40866 2.16699 10.0003C2.16699 14.592 5.90866 18.3337 10.5003 18.3337C15.092 18.3337 18.8337 14.592 18.8337 10.0003C18.8337 5.40866 15.092 1.66699 10.5003 1.66699ZM9.87532 6.66699C9.87532 6.32532 10.1587 6.04199 10.5003 6.04199C10.842 6.04199 11.1253 6.32532 11.1253 6.66699V10.8337C11.1253 11.1753 10.842 11.4587 10.5003 11.4587C10.1587 11.4587 9.87532 11.1753 9.87532 10.8337V6.66699ZM11.267 13.6503C11.2253 13.7587 11.167 13.842 11.092 13.9253C11.0087 14.0003 10.917 14.0587 10.817 14.1003C10.717 14.142 10.6087 14.167 10.5003 14.167C10.392 14.167 10.2837 14.142 10.1837 14.1003C10.0837 14.0587 9.99199 14.0003 9.90866 13.9253C9.83366 13.842 9.77532 13.7587 9.73366 13.6503C9.69199 13.5503 9.66699 13.442 9.66699 13.3337C9.66699 13.2253 9.69199 13.117 9.73366 13.017C9.77532 12.917 9.83366 12.8253 9.90866 12.742C9.99199 12.667 10.0837 12.6087 10.1837 12.567C10.3837 12.4837 10.617 12.4837 10.817 12.567C10.917 12.6087 11.0087 12.667 11.092 12.742C11.167 12.8253 11.2253 12.917 11.267 13.017C11.3087 13.117 11.3337 13.2253 11.3337 13.3337C11.3337 13.442 11.3087 13.5503 11.267 13.6503Z",
    fill: "#71717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.9c3e86efbc0b8371c5ad67fbaf094a78.svg";
export { ForwardRef as ReactComponent };